import { Component } from "react";
import Loader from "../../../../../utils/Loader";
import { ToastContainer } from "react-toastify";
import { withRouter } from "../../../../../utils/withRouter";
import { connect } from "react-redux";
import { fill_action } from '../../../../../actions/fillCombo_action';
import { cityActionId, countryActionId, toastError, toastSuccess, manualFormsPricesListActionId, BarActionId, MasterBarActionId, MasterCMFActionId } from "../../../../../utils/constants";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Modal from "react-modal";
import moment from "moment";
import AdminDrawer from "../../../../../common_components/admin_module_drawer";
import HeaderWithLogo from "../../../../../common_components/header_with_logo";
import { useNavigate } from "react-router-dom";
import ExhibitorDrawer from "../../../../../common_components/exhibitor_module_drawer";
import ExhibitorHeader from "../../../../../common_components/exhibitor_module_header";
import { data } from "jquery";
import { getManualformsMasterPricesList_action, insertUpdateManualformsMasterPricesList_action } from "../../../../../actions/admin_module_action/master_action/exhibition_master_action/exhManualFormPrices_action";


class Exh_ManualFormPrices extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isLoading: false,
            list: [],
            manualFormsList: [],
            ManualFormID: '',
            isOpen: false,
            toAdd: false,
            ExhibitionID: '',
            BarList: [],
            CFMList: [],
        }
    }

    componentDidMount() {
        this.getFillList(manualFormsPricesListActionId, '', '', '', '', '');
        this.getFillList(MasterBarActionId, "", "", "", "");
        this.getFillList(MasterCMFActionId, "", "", "", "");
        this.setState({
            ExhibitionID: this.props.location.state.ExhibitionID != undefined ? (this.props.location.state != null && this.props.location.state.ExhibitionID != null ? this.props.location.state.ExhibitionID : '') : this.props.id != null && this.props.id != undefined ? this.props.id : '',
        })
    }


    // Get Fill Lists
    getFillList(actionID, exhibitionID, moduleID, keyValue, value, from) {
        const { } = this.state
        this.setState({ isLoading: true })
        this.props
            .fill_action(actionID, exhibitionID, moduleID, keyValue, value)
            .then((data) => {
                if (data.error != 1) {
                    if (actionID === manualFormsPricesListActionId) {
                        this.setState({ manualFormsList: data.data, isLoading: false })
                    }
                    if (actionID === MasterBarActionId) {
                        this.setState({ BarList: data.data, isLoading: false })
                    }
                    if (actionID === MasterCMFActionId) {
                        this.setState({ CFMList: data.data, isLoading: false })
                    }
                }
                else {
                    this.setState({ isLoading: false })
                    toastError(data.msg)
                }
            })
            .catch((e) => {
                console.log(e);
            });
    }

    getManualFormsMasterList(ManualFormID) {
        this.setState({ isLoading: true })
        this.props.getManualformsMasterPricesList_action(this.state.ExhibitionID, ManualFormID)
            .then((data) => {
                if (data.error != 1) {
                    if (data.data.length > 0) {
                        this.setState({
                            list: data.data,
                            isAdd: false
                        })
                    }
                    else {
                        this.setState({ isAdd: true })
                    }
                    this.setState({ isLoading: false })
                }
                else {
                    this.setState({ isLoading: false })
                    toastError(data.msg)
                }
            })
            .catch((err) => {
                console.log(err)
            })
    }

    insertUpdateManualFormsMasterList() {
        this.setState({ isLoading: true })
        const { list, ExhibitionID, ManualFormID } = this.state
        this.props.insertUpdateManualformsMasterPricesList_action(ExhibitionID, ManualFormID, list)
            .then((data) => {
                if (data.error != 1) {
                    this.setState({ isLoading: false })
                    toastSuccess("update successfully")
                }
                else {
                    this.setState({ isLoading: false })
                    toastError(data.msg)
                }
            })
            .catch((err) => {
                console.log(err)
            })
    }


    onPriceINRChange(e, index) {
        e.preventDefault()
        const { list } = this.state
        list.map((data, i) => {
            if (index == i) {
                data.Amount_in_INR = parseFloat(e.target.value)
            }
        })
        this.setState({ list: list })
    }

    onPriceUSDChange(e, index) {
        e.preventDefault()
        const { list } = this.state
        list.map((data, i) => {
            if (index == i) {
                data.Amount_in_USD = parseFloat(e.target.value)
            }
        })
        this.setState({ list: list })
    }

    handleInput(e, index, param) {
        e.preventDefault()
        const { list } = this.state
        list.map((data, i) => {
            if (index == i) {
                if (param == 'Description') {
                    data.Description = e.target.value
                } else if (param == 'ServiceID') {
                    data.ServiceID = e.target.value
                } else if (param == 'CFMID') {
                    data.CFMID = e.target.value
                } else if (param == 'CutOffDateRateInINR') {
                    data.CutOffDateRateInINR = parseFloat(e.target.value)
                } else if (param == 'OnSiteRateInINR') {
                    data.OnSiteRateInINR = parseFloat(e.target.value)
                } else if (param == 'CutOffDateRateInUSD') {
                    data.CutOffDateRateInUSD = parseFloat(e.target.value)
                } else if (param == 'OnSiteRateInUSD') {
                    data.OnSiteRateInUSD = parseFloat(e.target.value)
                } else if (param == 'StandardRateInINR') {
                    data.StandardRateInINR = parseFloat(e.target.value)
                } else if (param == 'StandardRateInUSD') {
                    data.StandardRateInUSD = parseFloat(e.target.value)
                }
            }
        })
        this.setState({ list: list })
    }

    addRow() {
        this.setState(prevState => ({
            list: [
                ...prevState.list,
                {
                    ServiceID: '',
                    Description: '',
                    CFMID: '',
                    Amount_in_INR: 0,
                    Amount_in_USD: 0,
                    CutOffDateRateInINR: 0,
                    OnSiteRateInINR: 0,
                    CutOffDateRateInUSD: 0,
                    OnSiteRateInUSD: 0,
                }
            ]
        }))
    }

    deleteRow = (index) => {
        this.setState(prevState => ({
            list: prevState.list.filter((_, i) => i !== index)
        }))
    }

    moveUp = (index) => {
        if (index === 0) return

        this.setState(prevState => {
            const list = [...prevState.list]
                ;[list[index - 1], list[index]] = [list[index], list[index - 1]]
            return { list }
        })
    }

    moveDown = (index) => {
        this.setState(prevState => {
            if (index === prevState.list.length - 1) return null

            const list = [...prevState.list]
                ;[list[index], list[index + 1]] = [list[index + 1], list[index]]
            return { list }
        })
    }


    render() {
        const { isLoading, isOpen, list, manualFormsList, ManualFormID, BarList, CFMList } = this.state
        return (
            <>
                {isLoading ? (
                    <Loader></Loader>
                ) : (
                    null
                )}
                <ToastContainer />
                <HeaderWithLogo />
                <AdminDrawer />
                <div className="main-container p-2 mt-2">
                    <div className="main-container p-2">

                        <div className="row exb-top-space" >
                            <div className="col-md-4">
                                <label htmlFor="validationCustom03">Manual Form</label>
                                <select
                                    className="form-control"
                                    value={ManualFormID}
                                    onChange={(e) => this.setState({ ManualFormID: e.target.value, list: [] }, () => {
                                        if (e.target.value != '') {
                                            this.getManualFormsMasterList(e.target.value)
                                        }
                                    })}
                                >
                                    <option value={''}>Select</option>
                                    {manualFormsList.length > 0 &&
                                        manualFormsList.map((data) => (
                                            <option key={data.ManualFormID} value={data.ManualFormID}>
                                                {data.Name}
                                            </option>
                                        ))}
                                </select>
                            </div>
                        </div>
                        <div className="row">
                            <div class="table-responsive mt-3">
                                <table className="table border text-nowrap text-md-nowrap table-bordered mb-0">
                                    <thead>
                                        <tr>
                                            {ManualFormID == 13 ?
                                                <>
                                                    <th className="text-center" style={{ width: '10px' }}>Action</th>
                                                    <th className="text-center" >Description</th>
                                                    <th className="text-center" >Bar</th>
                                                    <th className="text-center" >CFM</th>
                                                </> :
                                                <>
                                                    <th className="text-center">ServiceName</th>
                                                </>
                                            }
                                            {ManualFormID != 2 ?
                                                <>
                                                    <th className="text-center" style={{ width: ManualFormID == 13 ? '150px' : '' }}>PI Amount (INR)</th>
                                                    <th className="text-center" style={{ width: ManualFormID == 13 ? '150px' : '' }}>PI Amount (USD)</th>
                                                    <th className="text-center" >Standard Rate <br />(INR)</th>
                                                    <th className="text-center">Cut-off Date Rate<br />
                                                        (INR)<br />
                                                        (Up to 30-10-2026)</th>
                                                    <th className="text-center">Onsite Rate <br />
                                                        (INR)<br />
                                                        (From 28-11-2026)</th>
                                                    <th className="text-center" >Standard Rate <br />
                                                        (USD)</th>
                                                    <th className="text-center">Cut-off Date Rate<br />
                                                        (USD)<br />
                                                        (Up to 30-10-2026)</th>
                                                    <th className="text-center">Onsite Rate<br />
                                                        (USD)<br />
                                                        (From 28-11-2026)</th>
                                                </> :
                                                <>

                                                    <th className="text-center">Amount (INR)</th>
                                                    <th className="text-center">Amount (USD)</th>
                                                </>
                                            }
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            list.length > 0 ? <>{
                                                list.map((data, i) => (
                                                    <tr key={i}>
                                                        {ManualFormID == 13 ?
                                                            <>
                                                                <td className="text-center">
                                                                    <button
                                                                        title="Delete FreightForward"
                                                                        class="btn btn-sm padding_0"
                                                                        onClick={() => this.deleteRow(i)}
                                                                    >
                                                                        <i class="fa fa-trash action_btn_table"></i>
                                                                    </button>
                                                                </td>
                                                                <td>
                                                                    <textarea
                                                                        className="form-control"
                                                                        placeholder=""
                                                                        value={data.Description}
                                                                        onChange={(e) => this.handleInput(e, i, 'Description')}
                                                                        style={{ height: '50px', width: '500px' }}
                                                                    />
                                                                </td>
                                                                <td>
                                                                    <select
                                                                        className="form-control"
                                                                        value={data.ServiceID}
                                                                        style={{ width: '130px' }}
                                                                        onChange={(e) => this.handleInput(e, i, 'ServiceID')}
                                                                    >
                                                                        <option value={''}>Select</option>
                                                                        {BarList.length > 0 &&
                                                                            BarList.map((data) => (
                                                                                <option key={data.ServiceID} value={data.ServiceID}>
                                                                                    {data.Name}
                                                                                </option>
                                                                            ))}
                                                                    </select>
                                                                </td>
                                                                <td>
                                                                    <select
                                                                        className="form-control"
                                                                        value={data.CFMID}
                                                                        style={{ width: '100px' }}
                                                                        onChange={(e) => this.handleInput(e, i, 'CFMID')}
                                                                    >
                                                                        <option value={''}>Select</option>
                                                                        {CFMList.length > 0 &&
                                                                            CFMList.map((data) => (
                                                                                <option key={data.CFMID} value={data.CFMID}>
                                                                                    {data.CFM}
                                                                                </option>
                                                                            ))}
                                                                    </select>
                                                                </td>
                                                            </> :
                                                            <>
                                                                <td>
                                                                    {data.ServiceName}
                                                                </td>
                                                            </>
                                                        }

                                                        {ManualFormID != 2 ?
                                                            <>
                                                                <td>
                                                                    <input
                                                                        type="number"
                                                                        className="form-control text-end"
                                                                        placeholder=""
                                                                        value={data.Amount_in_INR}
                                                                        onChange={(e) => this.onPriceINRChange(e, i)}
                                                                    />
                                                                </td>
                                                                <td>
                                                                    <input
                                                                        type="number"
                                                                        className="form-control text-end"
                                                                        placeholder=""
                                                                        value={data.Amount_in_USD}
                                                                        onChange={(e) => this.onPriceUSDChange(e, i)}
                                                                    />
                                                                </td>
                                                                <td>
                                                                    <input
                                                                        type="number"
                                                                        className="form-control text-end"
                                                                        placeholder=""
                                                                        value={data.StandardRateInINR}
                                                                        onChange={(e) => this.handleInput(e, i, 'StandardRateInINR')}
                                                                    />
                                                                </td>
                                                                <td>
                                                                    <input
                                                                        type="number"
                                                                        className="form-control text-end"
                                                                        placeholder=""
                                                                        value={data.CutOffDateRateInINR}
                                                                        onChange={(e) => this.handleInput(e, i, 'CutOffDateRateInINR')}
                                                                    />
                                                                </td>
                                                                <td>
                                                                    <input
                                                                        type="number"
                                                                        className="form-control text-end"
                                                                        placeholder=""
                                                                        value={data.OnSiteRateInINR}
                                                                        onChange={(e) => this.handleInput(e, i, 'OnSiteRateInINR')}
                                                                    />
                                                                </td>
                                                                <td>
                                                                    <input
                                                                        type="number"
                                                                        className="form-control text-end"
                                                                        placeholder=""
                                                                        value={data.StandardRateInUSD}
                                                                        onChange={(e) => this.handleInput(e, i, 'StandardRateInUSD')}
                                                                    />
                                                                </td>
                                                                <td>
                                                                    <input
                                                                        type="number"
                                                                        className="form-control text-end"
                                                                        placeholder=""
                                                                        value={data.CutOffDateRateInUSD}
                                                                        onChange={(e) => this.handleInput(e, i, 'CutOffDateRateInUSD')}
                                                                    />
                                                                </td>
                                                                <td>
                                                                    <input
                                                                        type="number"
                                                                        className="form-control text-end"
                                                                        placeholder=""
                                                                        value={data.OnSiteRateInUSD}
                                                                        onChange={(e) => this.handleInput(e, i, 'OnSiteRateInUSD')}
                                                                    />
                                                                </td>
                                                            </> :
                                                            <>
                                                                <td>
                                                                    <input
                                                                        type="number"
                                                                        className="form-control text-end"
                                                                        placeholder=""
                                                                        value={data.Amount_in_INR}
                                                                        onChange={(e) => this.onPriceINRChange(e, i)}
                                                                    />
                                                                </td>
                                                                <td>
                                                                    <input
                                                                        type="number"
                                                                        className="form-control text-end"
                                                                        placeholder=""
                                                                        value={data.Amount_in_USD}
                                                                        onChange={(e) => this.onPriceUSDChange(e, i)}
                                                                    />
                                                                </td>
                                                            </>
                                                        }
                                                    </tr>
                                                ))}
                                            </> :
                                                <tr><td colSpan={13} style={{ textAlign: 'center' }}>Record not found</td></tr>
                                        }
                                    </tbody>
                                </table>
                            </div>
                            {ManualFormID == 13 &&
                                <div style={{ textAlign: 'left' }} className="">

                                    <button type="button" class="btn btn-aqua rounded-0 mt-3 ms-2"
                                        onClick={(e) => this.addRow(e)}
                                    >
                                        Add +
                                    </button>
                                </div>
                            }
                            <div style={{ textAlign: 'right' }} >

                                <button type="button" class="btn btn-aqua rounded-1 mt-3 ms-2"
                                    onClick={(e) => this.insertUpdateManualFormsMasterList(e)}
                                    disabled={ManualFormID == ''}
                                >
                                    Submit
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        )
    }
}

export default withRouter(connect(null, { fill_action, getManualformsMasterPricesList_action, insertUpdateManualformsMasterPricesList_action })(Exh_ManualFormPrices));